<router-outlet></router-outlet>

<p-confirmDialog
  [draggable]="false"
  styleClass="!rounded-none"
  [style]="{ width: 'min(44rem, calc(100vw - 2rem))' }"
  [draggable]="false"
></p-confirmDialog>

<div *ngIf="showTestingEnvironmentNotice && !isProd" class="testing-environment-dialog-backdrop" role="presentation">
  <section class="testing-environment-dialog" role="dialog" aria-modal="true" aria-labelledby="testing-environment-title">
    <button type="button" class="testing-environment-dialog-close" aria-label="Cerrar aviso" (click)="closeTestingEnvironmentNotice()">
      <i class="pi pi-times"></i>
    </button>
    <div class="testing-environment-dialog-icon">
      <i class="pi pi-check-circle"></i>
    </div>
    <h2 id="testing-environment-title">Ambiente de pruebas listo</h2>
    <p>Estás ingresando al ambiente de pruebas. El nuevo ambiente de producción ya está disponible para operar.</p>
    <div class="testing-environment-dialog-actions">
      <button type="button" class="testing-environment-dialog-secondary" (click)="closeTestingEnvironmentNotice()">Continuar en pruebas</button>
      <a class="testing-environment-dialog-primary" href="https://chevronipcms.com" target="_blank" rel="noopener noreferrer">
        Ir a producción
        <i class="pi pi-arrow-up-right"></i>
      </a>
    </div>
  </section>
</div>

@if(isLoading) {
<div
  @fadeInOut
  class="fixed w-screen h-screen top-0 left-0 z-[5000] bg-white/20 backdrop-blur-md shadow-md flex justify-center items-center"
>
  <p-progress-spinner ariaLabel="loading" />
</div>
}

<!-- <div class="w-screen h-screen bg-green-900" > <p-button label="Submit" /> </div> -->
